var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDesfibrilacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56036 22.6415C9.93624 26.0298 19.9022 36 19.9022 36C19.9022 36 34.1808 21.709 34.3445 21.5328H34.3466C35.8635 19.8708 36.8023 17.585 36.8023 15.0608C36.8023 9.99182 33.0203 5.88232 28.3512 5.88232C23.6822 5.88232 19.9001 9.99182 19.9001 15.0608C19.9001 15.3137 19.9001 15.3137 19.9001 15.0608C19.9001 9.99182 16.116 5.88232 11.449 5.88232C6.78207 5.88232 3 9.99182 3 15.0608C3 17.27 3.71911 19.2967 4.91279 20.88L6.55828 22.6415H6.56036Z",
    fill: "#F5FBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9001 15.0608C19.9001 9.99182 23.6822 5.88232 28.3512 5.88232C33.0203 5.88232 36.8023 9.99182 36.8023 15.0608C36.8023 17.585 35.8635 19.8708 34.3466 21.5328H34.3445C34.1808 21.709 19.9022 36 19.9022 36C19.9022 36 9.93624 26.0298 6.56036 22.6415H6.55828L4.91279 20.88C3.71911 19.2967 3 17.27 3 15.0608C3 9.99182 6.78207 5.88232 11.449 5.88232C16.116 5.88232 19.9001 9.99182 19.9001 15.0608ZM19.9001 15.0608C19.9001 15.3136 19.9001 15.3136 19.9001 15.0608Z",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4043 4H27.2696C27.1066 4 26.9599 4.09886 26.8988 4.24991L22.9873 13.9127C22.8809 14.1756 23.0744 14.4627 23.3581 14.4627H26.4611C26.7294 14.4627 26.9217 14.7217 26.844 14.9785L23.542 25.8996C23.4089 26.3397 24.0019 26.6199 24.2574 26.2377L33.6427 12.1988C33.8204 11.933 33.6299 11.5765 33.3102 11.5765H30.8308C30.5318 11.5765 30.3385 11.2602 30.4749 10.9941L33.7603 4.58241C33.8967 4.31624 33.7034 4 33.4043 4Z",
    fill: "#F9839A",
    stroke: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDesfibrilacion);
export default __webpack_public_path__ + "static/media/Ic_desfibrilacion.3fd4e0f3a93e855c594aebc51c50cedf.svg";
export { ForwardRef as ReactComponent };